<div>
  <button #csvDownload class="btn cstm-btn-light" (click)="downloadCSV()">
    <i class="fa fa-download mr-2"></i>{{ "usersPage.csv" | cxTranslate }}
  </button>
</div>